import { KeyValueModel } from "../../model";

export const TpConfigObrigatorioMock: KeyValueModel[] = [
    new KeyValueModel(false, "Não"),
    new KeyValueModel(true, "Sim")
];